module.exports = __webpack_public_path__ + "img/login.8eccb8c7.png";